"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BtOpenChannelState = void 0;
var BtOpenChannelState;
(function (BtOpenChannelState) {
    /**
     * Channel is waiting for the required confirmations.
     */
    BtOpenChannelState["OPENING"] = "opening";
    /**
     * Channel is ready to transact.
     */
    BtOpenChannelState["OPEN"] = "open";
    /**
     * Channel is has been closed with at least 1 onchain confirmation.
     */
    BtOpenChannelState["CLOSED"] = "closed";
})(BtOpenChannelState = exports.BtOpenChannelState || (exports.BtOpenChannelState = {}));
//# sourceMappingURL=BtOpenChannelState.js.map